import { useEffect, useState } from "react";
import { animate } from "framer-motion";

// Animates a number from 0 → `to` on mount (and whenever `to` changes).
// Renders as a plain fragment so it can be dropped straight into a StatCard's
// `value`. Non-numeric `to` is rendered as-is (no animation).
export default function CountUp({ to = 0, duration = 0.9, decimals = 0, prefix = "", suffix = "" }) {
  const numeric = typeof to === "number" && !Number.isNaN(to);
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!numeric) return undefined;
    const controls = animate(0, to, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [to, duration, numeric]);

  if (!numeric) return <>{prefix}{to}{suffix}</>;
  return <>{prefix}{val.toFixed(decimals)}{suffix}</>;
}
